import React, { useEffect } from 'react';
import BrokerCarrierGrid from './BrokerCarrierGrid';
import ClaimsGrid from './ClaimsGrid';
import ClosedDocGrid from './ClosedDocGrid';
import DocumentTypeGrid from './DocumentTypeGrid';
import HistoricalDataGrid from './HistoricalDataGrid';
import FilterGridData from './FilterGridData';

const widgetComponentMap: Record<string, React.FC<any>> = {
  "Claims": ClaimsGrid,
  "Broker/Carriers": BrokerCarrierGrid,
  "Forced Complete": ClosedDocGrid,
  "Document Type": DocumentTypeGrid,
  // "Document Comparision": DocumentComparisonGrid,
  "Historical Data": HistoricalDataGrid,
};

const DashboardGrid = ({ selectedWidget, count, getDashboardCount }: any) => {
  const [filterValues, setFilterValues] = React.useState<any>(null);

  useEffect(() => {
    if(selectedWidget?.label !== "Historical Data") {
      setFilterValues(null);
    }
  }, [selectedWidget]);
  
  const SelectedComponent = widgetComponentMap[selectedWidget?.label];
  
  const getFilteredData = (values: any) => {
    setFilterValues(values);
  };

  return (
    <div>
      {selectedWidget?.label === "Historical Data" && 
      <FilterGridData onSearch={getFilteredData}/>}
      {SelectedComponent ? (
        selectedWidget.label === "Document Type" ? (
          <SelectedComponent count={count} docTypeId={selectedWidget.docTypeId} />
        ) : selectedWidget.label === "Historical Data" ? (
          <SelectedComponent count={count} filterValues={filterValues} />
        ) : selectedWidget.label === "Claims" ? (
          <SelectedComponent getDashboardCount={getDashboardCount} />
        ) : (
          <SelectedComponent count={count} />
        )
      ) : (
        <div className="text-muted py-4 px-3">
          No grid available for <strong>{selectedWidget?.label}</strong>.
        </div>
      )}
    </div>
  );
};

export default DashboardGrid;
